export default {
  CONTENT_IMAGES: 'institucional',
  SLIDERS: 'sliders',
  LEADS: 'leads',
  LETSBOOK: 'letsbook',
  CRM: 'crm',
  CONTENT_TEXT: 'texto',
  HEADER_FOOTER: 'header',
  PROMOTIONS: 'promocoes',
  ACCOMMODATIONS: 'acomodacoes',
  OTHERS: 'outros',
};
